import { designTokens } from '@/shared/lib/design-tokens'
import { cn } from '@/shared/lib'
import { routes } from '@/shared/config'

export type FooterProps = {
  leftLabel?: string
  rightLabel?: string | null
  leftHref?: string
  rightHref?: string
  onLeftClick?: () => void
  onRightClick?: () => void
  paddingBottom?: string
  className?: string
}

const footerTokens = designTokens.components.footer
const linkStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  fontSize: footerTokens.fontSize,
  lineHeight: footerTokens.lineHeight,
  fontWeight: footerTokens.fontWeight,
  color: footerTokens.textColor,
}

export function Footer({
  leftLabel = 'Пользовательское соглашение',
  rightLabel = 'Чат с поддержкой',
  leftHref = routes.userAgreement,
  // Поддержку ведёт @ps24supportbot — тот же бот, что в письмах кампании
  // и в мини-аппе. Старый бот поддержки Epic Growth оставлял людей во втором
  // окне, где им никто не отвечал.
  rightHref = 'https://t.me/ps24supportbot',
  onLeftClick,
  onRightClick,
  paddingBottom,
  className,
}: FooterProps) {
  const resolvedPaddingBottom = paddingBottom ?? footerTokens.paddingBottom
  const resolvedPaddingX = footerTokens.paddingX
  const hasLeftLabel = Boolean(leftLabel)
  const hasRightLabel = Boolean(rightLabel)

  return (
    <footer
      className={cn(
        'flex w-full items-center',
        hasLeftLabel && hasRightLabel ? 'justify-between' : 'justify-start',
        className
      )}
      style={{
        paddingBottom: resolvedPaddingBottom,
        paddingLeft: resolvedPaddingX,
        paddingRight: resolvedPaddingX,
      }}
    >
      {hasLeftLabel ? (
        <a style={linkStyle} href={leftHref} target="_blank" rel="noreferrer" onClick={onLeftClick}>
          {leftLabel}
        </a>
      ) : null}
      {hasRightLabel ? (
        <a
          style={linkStyle}
          href={rightHref ?? undefined}
          target="_blank"
          rel="noreferrer"
          onClick={onRightClick}
        >
          {rightLabel}
        </a>
      ) : null}
    </footer>
  )
}
